export default "__VITE_ASSET__CVSjTo5u__"